import { render, staticRenderFns } from "./CAxACGxClarificationsPage.vue?vue&type=template&id=5e31dc5c"
import script from "./CAxACGxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxACGxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxACGxClarificationsPage.vue?vue&type=style&index=0&id=5e31dc5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports